var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarMockTestWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3202 7.96094L16.7421 1.85547C16.7128 1.53906 16.4608 1.28906 16.1444 1.25781L10.0389 0.679688H10.0311C9.96862 0.679688 9.91979 0.699219 9.88268 0.736328L0.736195 9.88281C0.718089 9.90088 0.703724 9.92234 0.693923 9.94597C0.684122 9.9696 0.679077 9.99493 0.679077 10.0205C0.679077 10.0461 0.684122 10.0714 0.693923 10.095C0.703724 10.1187 0.718089 10.1401 0.736195 10.1582L7.84166 17.2637C7.87877 17.3008 7.9276 17.3203 7.98033 17.3203C8.03307 17.3203 8.0819 17.3008 8.11901 17.2637L17.2655 8.11719C17.3046 8.07617 17.3241 8.01953 17.3202 7.96094ZM12.6522 6.55859C11.9628 6.55859 11.4022 5.99805 11.4022 5.30859C11.4022 4.61914 11.9628 4.05859 12.6522 4.05859C13.3417 4.05859 13.9022 4.61914 13.9022 5.30859C13.9022 5.99805 13.3417 6.55859 12.6522 6.55859Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMockTestWhite);
export default __webpack_public_path__ + "static/media/sidebar-mock-test-white.714c1cbac43f42389ff049199df29a3b.svg";
export { ForwardRef as ReactComponent };